import axios from "axios";
import { BASE_URL, SUB_URL } from "../BaseUrl";

const MasterBinService ={
    masterBin_get_bins_details : async()=>{
        const response = await axios.get(`${BASE_URL.BASE_URL}${BASE_URL.API_URL}${SUB_URL.getMaster_get_bins_details}`);
        return response.data;
    }
};

export default MasterBinService;